import { Colors, Fonts } from '../../theme';
import colors from '../../theme/colors';
import commonStyle from '../../theme/common-style';
import metrics from '../../theme/metrics';
import styleText from '../rbh-text/styles';
import styleTextInput from '../../../shared/components/rbh-textinput/styles';

const boxWrapper = {
  borderStyle: 'solid',
  borderColor: Colors.white,
  borderWidth: metrics.borderWidth,
  borderRadius: metrics.base,
  backgroundColor: Colors.white
};

export default {
  default: {
    paddingLeft: '25px',
    paddingRight: '25px',
    paddingTop: '45px',
    paddingBottom: '45px',
    borderStyle: 'solid',
    borderColor: Colors.white,
    borderWidth: '1px',
    borderRadius: '10px',
    width: '400px',
    backgroundColor: Colors.white,
  },
  deleteDiscount: {
    borderColor: Colors.white,
    backgroundColor: Colors.white,
    border: `1px solid ${Colors.white}`,
    borderRadius: '10px',
    padding: '24px 16px 16px 16px',
    width: '480px',
  },
  map: {
    padding: '30px',
    width: '600px',
    backgroundColor: Colors.white,
  },
  successIcon: {
    fontSize: Fonts.size.text48,
    color: Colors.successGreen
  },
  line: {
    borderWidth: metrics.borderWidth,
    borderBottomWidth: 0,
    borderColor: '#D9D9D9',
    borderStyle: 'solid'
  },
  listViewContainer: {
    width: '600px',
    height: '600px',
    borderStyle: 'solid',
    borderColor: Colors.white,
    borderWidth: metrics.borderWidth,
    borderRadius: '10px',
    backgroundColor: Colors.white
  },
  listViewHeader: {
    padding: metrics.base * 2
  },
  listViewHeaderText: {
    ...Fonts.style.textHeaderKanitSemiBold20,
    color: colors.font.primary.fakeBlack
  },
  listViewPopoverText: {
    ...Fonts.style.textHeaderKanitRegular14
  },
  listViewContent: {
    overflow: 'scroll',
    padding: metrics.base * 2,
    height: '506px'
  },
  listViewSubtitleText: {
    ...Fonts.style.textHeaderKanitRegular14,
    color: colors.font.primary.darkGray,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
  popoverContainer: {
    width: '560px',
    ...Fonts.style.textHeaderKanitRegular14,
    color: colors.white,
    backgroundColor: colors.font.primary.fakeBlack,
    borderRadius: '4px',
    padding: metrics.baseMargin,
    position: 'absolute',
    top: metrics.base * 8
  },
  popoverTriangle: {
    backgroundColor: colors.font.primary.fakeBlack,
    top: metrics.base * 7.5,
    left: '50%',
    position: 'absolute',
    width: 11,
    height: 11,
    transform: 'rotate(45deg)'
  },
  vatTaxesIndexContainer: {
    width: '600px',
    height: '326px',
    borderStyle: 'solid',
    borderColor: Colors.white,
    borderWidth: metrics.borderWidth,
    borderRadius: '10px',
    backgroundColor: Colors.white,
    boxShadow: '0px 5px 5px rgba(0, 0, 0, 0.5)'
  },
  vatTaxesPopupButton: {
    padding: '20px 20px 20px 324px'
  },
  posSaveAndLeave: {
    ...Fonts.style.textHeaderKanitRegular16,
    background: 'linear-gradient(230.89deg, #7F50B2 0%, #CF1E91 100%',
    color: Colors.white,
    borderColor: Colors.lightPurple,
    height: '40px',
    width: '200px',
    borderRadius: 5,
    marginBottom: '16px',
    marginTop: '24px'
  },
  posLeaveOnly: {
    ...Fonts.style.textHeaderKanitRegular16,
    background: 'transparent',
    borderColor: Colors.lightPurple,
    height: '40px',
    width: '200px',
    color: Colors.lightPurple,
    borderRadius: 5
  },
  posNoFoodFoundCancel: {
    ...Fonts.style.textHeaderKanitRegular16,
    background: 'transparent',
    borderColor: Colors.lightPurple,
    height: '40px',
    width: '160px',
    color: Colors.lightPurple,
    borderRadius: 5
  },
  posNoFoodFoundToFoodMenu: {
    ...Fonts.style.textHeaderKanitRegular16,
    background: 'linear-gradient(230.89deg, #7F50B2 0%, #CF1E91 100%',
    color: Colors.white,
    borderColor: Colors.lightPurple,
    height: '40px',
    width: '160px',
    borderRadius: 5
  },
  posDetailBox: {
    width: '600px',
    height: '388px',
    borderRadius: '10px',
    backgroundColor: Colors.white,
    boxShadow: '0px 5px 5px rgba(0, 0, 0, 0.5)',
    borderStyle: 'solid',
    borderColor: Colors.white,
    borderWidth: metrics.borderWidth,
  },
  posDetailHeaderText: {
    ...Fonts.style.textHeaderKanitSemiBold20,
    textAlign: 'left',
    color: Colors.font.primary.fakeBlack
  },
  posDetailLabelText: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.darkGray
  },
  posDetailDataText: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.fakeBlack
  },
  regularPurple14under: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    textDecoration: 'underline',
    color: Colors.lightPurple,
    cursor: 'pointer',
  },
  tagPs03noDate: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text12,
    color: Colors.white,
    background: Colors.tagGreen,
  },
  pickReportBox: {
    ...boxWrapper,
    padding: metrics.baseMargin * 1.25,
    width: metrics.baseMargin * 42.5
  },
  pickReportRadioBox: {
    paddingTop: metrics.baseMargin * 1.25
  },
  pickReportHeader: {
    ...Fonts.style.header,
    color: Colors.font.primary.fakeBlack,
  },
  pickReportDesc: {
    ...Fonts.style.textHeaderKanitRegular14,
    color: Colors.font.primary.darkGray,
    paddingBottom: metrics.baseMargin * 1.25
  },
  reportType1: {
    ...Fonts.style.textHeaderKanitRegular16,
    color: Colors.font.primary.fakeBlack,
  },
  reportType2: {
    ...Fonts.style.textHeaderKanitRegular16,
    color: Colors.font.primary.fakeBlack,
  },
  typeDesc: {
    ...Fonts.style.textHeaderKanitRegular14,
    color: Colors.font.primary.darkGray,
    paddingLeft: (metrics.baseMargin * 2) - 3
  },
  type1Desc3: {
    ...Fonts.style.textHeaderKanitRegular14,
    color: Colors.font.primary.darkGray,
    paddingLeft: (metrics.baseMargin * 2) - 3,
    paddingBottom: metrics.baseMargin
  },
  type2Desc3: {
    ...Fonts.style.textHeaderKanitRegular14,
    color: Colors.font.primary.darkGray,
    paddingLeft: (metrics.baseMargin * 2) - 3,
    paddingBottom: metrics.baseMargin * 1.25
  },
  remark: {
    ...Fonts.style.textHeaderKanitRegular14,
    color: Colors.font.primary.darkGray,
    paddingTop: metrics.baseMargin * 1.25,
    paddingBottom: metrics.baseMargin * 1.25
  },
  productLimitBox: {
    ...boxWrapper,
    width: metrics.base * 60
  },
  productLimitHeader: {
    ...Fonts.style.headerFakeBlack,
    color: Colors.font.primary.fakeBlack,
  },
  piecesPerPackTitle: {
    ...styleText.textRegular16,
    color: Colors.font.primary.fakeBlack,
    paddingBottom: metrics.base * 2
  },
  productLimitTitle: {
    ...styleText.textRegular16,
    color: Colors.font.primary.fakeBlack,
    paddingTop: metrics.base * 2,
    paddingBottom: metrics.baseMargin
  },
  productLimitOption: {
    ...Fonts.style.textHeaderKanitRegular14,
    color: Colors.font.primary.fakeBlack,
    paddingBottom: metrics.base - 0.5,
    paddingTop: metrics.base - 0.5
  },
  weightSizeLimit: {
    ...styleTextInput.inputWidth276
  },
  sizeLimitBox: {
    ...commonStyle.paddingLeftLarge,
    ...commonStyle.paddingBottom
  },
  sizeLimit: {
    ...styleTextInput.inputWidth276
  },
  getSelectWeightLimit: {
    width: metrics.base * 10
  },
  piecesPerPackOption2Input: {
    ...styleTextInput.inputWidth276
  }
};
